// extracted by mini-css-extract-plugin
module.exports = {"content":"QualificationsSection_content__1m-ih"};